export default __webpack_public_path__ + "static/media/exterior7.7b98ca01.webp";